import Elemento from "./Elemento.js";

export default class Side extends Elemento {
  constructor() {
    super();
    this.nImagenesDraw;
    this.grupos = new Array();
    this.perfil = {
      material: "",
    };
    this.perfilRevestimiento;
    this.GetGrupo = function (cod) {
      return this.grupos.filter((grupo) => grupo.cod == cod)[0];
    };
    this.GetCampo = function (cod) {
      var campo = null;
      var campos;

      this.grupos.forEach((grupo) => {
        campos = grupo.campos.filter((campo) => campo.cod == cod);
        if (campos.length > 0) {
          campo = campos[0];
        }
      });

      return campo;
    };
    this.EsError = function (perfil) {
      var status = false;

      this.grupos.forEach((grupo) => {
        status = status || grupo.EsError(perfil);
      });

      return status;
    };
    this.ResolveCondicion = function (Condicion) {
      var Status = true;

      if (Condicion != "" && Condicion != undefined) {
        try {
          var perfil = this.perfil;
          Status = eval(Condicion);
        } catch (error) {
          //console.log(this.cod);
          //console.log("Error", error);
          //console.log("Condicion", this.condicion);
          //console.log("Perfil", perfil);
        }
      }

      return Status;
    };
    this.SetPerfil = function (grupo, campo, value) {
      if (grupo == "REVESTIMIENTO") {
        if (this.perfilRevestimiento[campo] != undefined) {
          this.perfilRevestimiento[campo].value = value;
        }
      } else {
        if (this.perfil[campo] != undefined) {
          this.perfil[campo].value = value;
        }
      }
    };
    this.GetNombreArchivo = function (campo, acabado) {
      // Este método está Hardcodeado para transformar el nombre de la característica en una
      // aplicación de tipo estándar.
      // Vidrio hay que hardcodearlo porque en realidad lo forman 2 campos (vidrio y decorado) que
      // nos llegan sólo en 1.
      // El resto podría hacerse sin hardcode con la excel de converión configurable/estándar pero
      // son tan pocos los códigos que por el momento se queda así.
      // Si se diera más casuística se cambiaría.
      let nombre;

      if (campo.compuesto != undefined) {
        if (
          campo.cod == "tirador" ||
          campo.cod == "POMO_ST" ||
          campo.cod == "POMO"
        ) {
          //POMO_ST-COLOR_PERFIL_ST&00-CR.webp
          //console.log(acabado.cod.padStart(2, "0"));

          if (acabado.cod.padStart(2, "0") == "00") {
            nombre = "POMO_ST&00";
          } else {
            nombre =
              "POMO_ST" +
              "-" +
              "COLOR_PERFIL_ST" +
              "&" +
              acabado.cod.padStart(2, "0") +
              "-" +
              campo.compuesto.acabadoSel.cod;
          }
        } else {
          nombre =
            campo.cod +
            "-" +
            campo.compuesto.cod +
            "&" +
            acabado.cod +
            "-" +
            campo.compuesto.acabadoSel.cod;
        }
      } else if (campo.campoFiltro != undefined) {
        nombre =
          campo.campoFiltro.cod +
          "-" +
          campo.cod +
          "&" +
          acabado.cod +
          "-" +
          campo.acabadoSel.cod;
      } else {
        if (campo.cod == "vidrio") {
          if (acabado.cod == "0" || acabado.cod == "00") {
            // Incoloro
            nombre = "TIPO_VIDRIO" + "&" + "01";
          } else {
            // Siempre es en color blanco...
            nombre =
              "DECORADO-COLOR_DECORADO" +
              "&" +
              acabado.cod.padStart(2, "0") +
              "-" +
              "01";
          }
        } else {
          if (campo.cod == "perfil") {
            nombre = "COLOR_PERFIL_ST" + "&" + acabado.cod;
          } else {
            nombre = campo.cod + "&" + acabado.cod;
          }
        }
      }
      return nombre;
    };
    this.GetTaco = function (campo, acabado) {
      return this.GetNombreArchivo(campo, acabado) + ".webp";
    };
    this.GetModal = function (campo, acabado) {
      return this.GetNombreArchivo(campo, acabado) + "&MODAL.webp";
    };
    this.priceObj = {};
  }
}
